import React from 'react';
import { SplitButtonStyles as S } from './SplitButton.styles';
import Button, { LinkButton } from '../Button/Button';
import { useClickAway } from 'react-use';
import ChevronDown from '@img/icons/chevron-down.svg';
import { withMotion } from '@hoc/withMotion';
const SplitButton = (props) => {
    const [active, setActive] = React.useState(false);
    const ref = React.useRef(null);
    useClickAway(ref, () => setActive(false));
    return (React.createElement(S.Container, { ref: ref, "data-active": active },
        React.createElement(Button, { ...props.outerCta, theme: props.outerCta.theme ?? 'white', variant: props.outerCta.variant ?? 'button', icon: props.outerCta.icon ?? 'chevron-down', iconPosition: "right", onClick: (e) => {
                e.stopPropagation();
                setActive(!active);
            } }, props.outerCta.text),
        React.createElement(S.FloatingCtas, { onClick: (e) => e.stopPropagation() },
            props.innerCta1 && (React.createElement(LinkButton, { href: props.innerCta1.url, target: props.innerCta1.target, theme: props.innerCta1.theme ?? 'white', themeHover: props.innerCta1.themeHover ?? 'light-blue', variant: props.innerCta1.variant ?? 'button', icon: props.innerCta1.icon, iconPosition: "right" }, props.innerCta1.text)),
            props.innerCta1 && props.innerCta2 && React.createElement(S.Separator, null),
            props.innerCta2 && (React.createElement(LinkButton, { href: props.innerCta2.url, target: props.innerCta2.target, theme: props.innerCta2.theme ?? 'white', themeHover: props.innerCta2.themeHover ?? 'light-blue', variant: props.innerCta2.variant ?? 'button', icon: props.innerCta2.icon, iconPosition: "right" }, props.innerCta2.text)))));
};
export default SplitButton;
const _SplitButtonMobile = (props) => {
    const [active, setActive] = React.useState(false);
    return (React.createElement(S.Container, { "data-active": active, onClick: () => setActive(!active) },
        React.createElement(S.MobileButton, null,
            React.createElement("span", null, props.outerCta.text),
            React.createElement(ChevronDown, null)),
        React.createElement(S.Collapse, { "data-active": active },
            React.createElement(S.CollapseInner, null,
                props.innerCta1 && (React.createElement("a", { href: props.innerCta1.url, target: props.innerCta1.target }, props.innerCta1.text)),
                props.innerCta2 && (React.createElement("a", { href: props.innerCta2.url, target: props.innerCta2.target }, props.innerCta2.text))))));
};
export const SplitButtonMobile = withMotion(_SplitButtonMobile);
